// Shamelessly taken from https://github.com/sindresorhus/p-debounce

const promisedDebounce = (fn, wait, opts) => {
  // @ts-expect-error ts-migrate(2367) FIXME: This condition will always return 'false' since th... Remove this comment to see the full error message
  if (!typeof wait === 'number' || !isFinite(wait)) {
    throw new TypeError('Expected `wait` to be a finite number');
  }
  opts = opts || {};
  let leadingVal;
  let timer;
  let resolveList = [];
  return function (...args) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const ctx = this;
    return new Promise(resolve => {
      const runImmediately = opts.leading && !timer;
      clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        const res = opts.leading ? leadingVal : fn.apply(ctx, args);
        for (resolve of resolveList) {
          resolve(res);
        }
        resolveList = [];
      }, wait);
      if (runImmediately) {
        leadingVal = fn.apply(ctx, args);
        resolve(leadingVal);
      } else {
        resolveList.push(resolve);
      }
    });
  };
};
export default promisedDebounce;